import Back from './back'

export default {
    install: function(Vue) {
        Vue.component('Back', Back)
    }
}